module.exports = __webpack_public_path__ + "static/media/waitlist-member-2.c6e8fdcc.jpeg";